import React from 'react';
import { motion } from 'framer-motion';
interface SectionWrapperProps {
  children: ReactNode;
  className?: string;
  id?: string;
  delay?: number;
}
export function SectionWrapper({
  children,
  className = '',
  id,
  delay = 0
}: SectionWrapperProps) {
  return <motion.section id={id} initial={{
    opacity: 0,
    y: 30
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-100px'
  }} transition={{
    duration: 0.8,
    ease: 'easeOut',
    delay
  }} className={`py-16 md:py-24 px-6 md:px-8 max-w-4xl mx-auto ${className}`} data-id="element-2">
      {children}
    </motion.section>;
}